import '@jack-henry/jh-ui/components/button/button.js';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../../tm-base.component';
import { TmButtonType } from '../tm-button.types';
import { ifDefined } from 'lit/directives/if-defined.js';

const tagName = 'tm-jh-button';

@customElement(tagName)
export class TmButton extends TmBaseComponent {
    @property({ type: String })
    public label?: string;

    @property({ type: Boolean })
    public disabled = false;

    @property({ type: String })
    public appearance?: 'primary' | 'secondary' | 'tertiary';

    @property({ type: Boolean })
    public loading = false;

    @property({ type: String, attribute: 'name' })
    public name?: string;

    @property({ type: String })
    public size: 'flex' | 'small' | 'medium' | 'large' = 'medium';

    @property({ type: String, reflect: true })
    public type: TmButtonType = TmButtonType.None;

    protected render() {
        return html`<jh-button
            .disabled=${this.disabled || this.loading}
            label=${ifDefined(this.label)}
            appearance=${ifDefined(this.appearance)}
            name=${ifDefined(this.name)}
            size=${ifDefined(this.size)}
        >
            ${this.label}
            ${this.loading
                ? html`<jha-progress slot="jh-button-icon"></jha-progress>`
                : html`<slot name="icon" slot="jh-button-icon"></slot>`}
        </jh-button> `;
    }

    public static get styles() {
        return css`
            jh-button[size='flex'] {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0;
                width: inherit;
                height: inherit;
                min-width: inherit;
                --jh-button-size: inherit;
                --jh-space-200: 0;
                --jh-space-400: 0;
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmButton;
    }
}
